import DPO from 'dpo8core';
import RotateIconMobile from '@images/icons/rotate-mobile.svg';
import RotateIcon from '@images/icons/rotate.svg';
import ResizeIcon from '@images/icons/resize.svg';

export const getEditorConfig = isMobileView => {
  const {
    defaultSettings: { rotateControl: rotateControllSettings },
  } = DPO.render.PointerTransformTool;

  const keepAspectRatio = [DPO.model.Barcode, DPO.model.Image, DPO.model.Drawing];
  const rotateControl = {
    size: 25,
    ...(isMobileView
      ? {
          icon: RotateIconMobile,
          params: {
            position: 's',
            customLineIndent: -25 / 2,
          },
        }
      : {
          ...rotateControllSettings,
          icon: RotateIcon,
        }),
  };
  const trackingControls = isMobileView
    ? [
        {
          size: 25,
          icon: ResizeIcon,
          params: {
            direction: 'se',
            action: 'resize',
            keepAspectRatio,
          },
        },
      ]
    : [
        { size: 8, icon: null, params: { direction: 'nw', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'n', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'ne', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'e', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'se', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 's', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'sw', action: 'resize', keepAspectRatio } },
        { size: 8, icon: null, params: { direction: 'w', action: 'resize', keepAspectRatio } },
      ];

  return {
    enableAutoZoom: true,
    transformToolSettings: {
      rotateControl,
      trackingControls,
      ...(isMobileView && {
        multiPointersEnabled: true,
        fieldMinWidth: 10,
        fieldMinHeight: 10,
      }),
    },
    ...(isMobileView && {
      canvasVisibility: 0.5,
      minZoom: 0.05,
    }),
  };
};

export const clearProjectFields = ({ project: { pages = [], masterPanels = [] } = {} }) => {
  pages.forEach(({ panels }) => panels.forEach(panel => {
    panel.images = [];
    panel.fieldRefs = [];
    panel.groups = [];
  }));
  masterPanels.forEach(mp => {
    mp.images = [];
    mp.groups = [];
  });
}
